import usePendingAction, { requestWithCallbacks } from "shared/utils/usePendingAction.js";
import React, { useState } from "react";
import { NotificationManager as nm } from "react-notifications";
import Popup from "reactjs-popup";
import { addTeam } from "shared/services/api-assistant.js";
import { prettifyId } from "shared/utils/graphql.js";

interface PopupAddTeamProps {
  trigger: Object;
  onClose: func;
  onConfirm?: func;
}

const PopupAddTeam: React.FC<PopupAddTeamProps> = ({ trigger, onClose, onConfirm }) => {
  const [name, setName] = useState("");

  const { isPending, run } = usePendingAction();

  const confirm = (close) => run(async () => {
    await requestWithCallbacks(addTeam, { params: { name } });
    await onConfirm?.();
    nm.info("The team has been added");
    close();
    setName("");
  });

  return (
    <div className="PopupAddTeam">
      <Popup trigger={trigger} modal closeOnDocumentClick={false} onClose={onClose} closeOnEscape={!isPending} className={"fade-in popup-md"}>
        {(close) => (
          <div>
            <div className="d-flex flex-row mb-3">
              <div className="flex-grow-1">
                <h2 className="text-white">Add a new team</h2>
              </div>
              <div className="flex-grow-0">
                <button className={"btn"} disabled={isPending} onClick={close}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <div className="d-flex flex-row justify-content-end mt-3">
              <input
                type="text"
                className="form-control w-100"
                disabled={isPending}
                value={name}
                onChange={(v) => setName(v.target.value)}
                placeholder={"Team name"}
                autoFocus
              />
              <div>
                <button className="btn btn-info text-white" disabled={isPending || name.length < 3} onClick={() => confirm(close)}>
                  {isPending ? <span className="d-inline-flex align-items-center gap-2 primary-color" role="status"><span className="spinner-border spinner-border-sm" aria-hidden="true" />Saving…</span> : "Confirm"}
                </button>
              </div>
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default PopupAddTeam;
